import React from 'react'
import Item from './item'
import Banners from '../banners'
interface ICashBoxesProps {
    cashBoxes: Array<ICashBoxes>
}
export default function CashBoxes({ cashBoxes }: ICashBoxesProps) {
    return (
        <div>
            {cashBoxes.map((item, index) => (
                <div key={item.id}>
                    <Item item={item} />
                    {index === 0 && <Banners />}
                </div>
            ))}
        </div>
    )
}
